module.exports = __webpack_public_path__ + "img/pdf-icon.21206e11.svg";